import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {capitalize} from "@String/capitalize";

interface HowMuchContentProps {
    departure: string,
    destination: string,
    availableTransportation: string,
    cheapestPrice: string,
}

function HowMuchContent({departure, destination, availableTransportation, cheapestPrice}: HowMuchContentProps) {
    const title = useTranslation(
        `${singleModalTranslationKey}.how_much.title`,
        {departure, destination}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_much.description`,
        {departure, destination, availableTransportation: capitalize(availableTransportation), cheapestPrice}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowMuchContent